import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Jeff Anders
 * id 783621A3-B8D0-4340-BE29-0399B02EAE6B
 * name shape-square-rounded-plus
 * version: 5.4.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/shape-square-rounded-plus.svg
 * tags
 */
export const ShapeSquareRoundedPlusIcon = createSvgIcon(<><path d="M17 2H19V5H22V7H19V10H17V7H14V5H17V2M7 5H11V7H7C5.9 7 5 7.9 5 9V17C5 18.11 5.9 19 7 19H15C16.11 19 17 18.11 17 17V13H19V17C19 19.21 17.21 21 15 21H7C4.79 21 3 19.21 3 17V9C3 6.79 4.79 5 7 5Z" /></>, 'ShapeSquareRoundedPlusIcon');
export default ShapeSquareRoundedPlusIcon